export default __webpack_public_path__ + "static/youtube-3eaaeb3c54f3634c0f265f136d87ba68.svg";